import { useMemo } from "react";

import { useSelector } from "../store";
import { useListFeatureFlagsQuery } from "../store/pomeriumApi";

type FeatureFlag =
  | "hosted-clusters"
  | "hosted-clusters-unconstrained"
  | "idp-tokens"
  | "depends-on"
  | "otlp-tracing"
  | "ssh-tunnels"
  | "mcp-pomerium-app-ui-banner";

function useFeatureFlag(name: FeatureFlag, defaultValue: boolean) {
  const organizationId = useSelector((state) => state.current.organizationId);
  const { data: featureFlags } = useListFeatureFlagsQuery(organizationId, {
    skip: !organizationId,
  });
  const featureFlag = useMemo(
    () => featureFlags?.find((ff) => ff.name === name),
    [featureFlags],
  );
  const dbEnabled = featureFlag ? featureFlag.enabled : defaultValue;
  return dbEnabled;
}
export default useFeatureFlag;
